import { useSelector } from "react-redux";

import { colorsPalettes } from "@similarweb/styles";
import { TruncatedTextWithTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { extractCrmAndObjectType } from "app/pages/sales-intelligence/sub-modules/opportunities/helpers/crmList";
import { selectRecentlyViewedOpportunityList } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";

import type { OpportunityListOption } from "../../../../types";
import { OpportunityListVariant } from "../../../../types";

import {
    StyledListsDropdownItem,
    StyledListName,
    StyledListWebsitesCount,
    StyledIcon,
    StyledAssignedAccountsIcon,
    StyledAutoCreatedTag,
} from "./styles";

type ListsDropdownItemProps = {
    list: OpportunityListOption;
    onClick(list: OpportunityListOption): void;
};

const ListsDropdownItem = (props: ListsDropdownItemProps) => {
    const { list, onClick } = props;
    const recentlyViewedList = useSelector(selectRecentlyViewedOpportunityList);
    const isRecentlyViewedList = list.id === recentlyViewedList?.opportunityListId;
    const isAutoCreateList = isRecentlyViewedList || list.variant === OpportunityListVariant.Crm;

    const getIcon = () => {
        if (list.variant === OpportunityListVariant.Crm) {
            const { crm } = extractCrmAndObjectType(list.id);
            return (
                <StyledIcon
                    iconName={crm}
                    size="sm"
                />
            );
        }

        if (list.name === "Assigned accounts") {
            return (
                <StyledAssignedAccountsIcon
                    iconName="assign-to-user"
                    size="sm"
                />
            );
        }

        return (
            <StyledIcon
                iconName="list-icon"
                size="sm"
            />
        );
    };

    return (
        <StyledListsDropdownItem
            onClick={() => onClick(list)}
            data-automation={`si-lists-dropdown-item-${list.id}`}
        >
            {getIcon()}
            <StyledListName>
                <TruncatedTextWithTooltip
                    fontVariant="body2"
                    color={colorsPalettes.carbon[500]}
                >
                    {isRecentlyViewedList ? translate("si.opportunity-list.auto-created.title") : list.name}
                </TruncatedTextWithTooltip>
                {isAutoCreateList ? <StyledAutoCreatedTag isSmall /> : null}
            </StyledListName>
            <StyledListWebsitesCount data-automation="websites-count-wrap">
                <span data-automation="websites-count">{list.opportunitiesCount}</span>
            </StyledListWebsitesCount>
        </StyledListsDropdownItem>
    );
};

export default ListsDropdownItem;
